module.exports = __webpack_public_path__ + "img/crazy-pizza_0.09511b6a.jpg";